<template>
  <div class="d-block d-sm-flex justify-space-between align-center">
    <div class="d-flex flex-column">
      <div>
        <h6 class="font font--money-label font--color_dark mb-2">Доступно для вывода</h6>
        <div v-if="balance_free !== null" class="font font--big">
          {{ makeRub(balance_free) }}
        </div>
        <div v-else class="balance--loader">
          <v-icon large>mdi-loading</v-icon>
        </div>
      </div>
    </div>
    <div class="pt-5 pt-sm-0">
      <!-- <v-btn @click="toogleNewYear(true)" color="success" class="mb-2  mr-2">
        <v-img class="mr-2" width="20" src="@/assets/img/bonusIcon.svg"></v-img>Акция 10 000 руб. за счет</v-btn
      > -->

      <v-btn :disabled="!canWithdraw" @click="openWithdraw" color="primary" class="mb-2">Вывести вознаграждение</v-btn>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapMutations } from "vuex";
import { makeRub } from "@/mixins/makeRub";

export default {
  name: "BillingBalanceContainer",

  mixins: [makeRub],

  computed: {
    ...mapGetters("profile", ["isRegStepper", "canSeeBilling"]),
    ...mapGetters("billing", ["canWithdraw"]),

    balance_free() {
      return this.$store.state.billing.balance_free;
    },
  },

  methods: {
    ...mapMutations("common", ["toogleNewYear"]),

    openWithdraw() {
      this.$emit("update:withdraw", true);
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@/styles/_variables";

.balance--loader .v-icon.mdi-loading {
  color: $primary;
  animation: circle 1s linear infinite;
}

@keyframes circle {
  0% {
    transform: rotate(0deg);
  }
  50% {
    transform: rotate(90deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
</style>
